const utilBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(
  navigator.userAgent
);

if (
  localStorage.getItem("paleofStaff") ||
  window.Shopify.designMode ||
  utilBot
) {
  console.log("es paleof staff");
} else {
  const urlParams = new URLSearchParams(window.location.search);
  const adminParam = urlParams.get("adminpaleo");

  if (adminParam) {
    localStorage.setItem("paleofStaff", true);
    console.log("es paleof staff");
  } else {
    // Get user's IP
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(ipData => {
        const userIP = ipData.ip;
        
        // Fetch country from new API
        return fetch('https://geo.acro.fyi/api/country', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': 'f246970acb0ebb0e563e6f9105bb82b3f0b09ad69376b7c846fcb631a6366580'
          },
          body: JSON.stringify({ ip: userIP })
        });
      })
      .then(response => response.json())
      .then(data => {
        console.log("acrogeo", data);
        if (
          data.country.code === "DE" ||
          data.country.code === "PT" ||
          data.country.code === "NL" ||
          data.country.code === "ES" ||
          data.country.code === "IT"
        ) {
          location.href = "https://www.paleolife.es";
        }
        // if (data.country.code === "US") {
        //   location.href = "https://paleolf.us" + location.pathname;
        // }
      })
      .catch(error => {
        console.error('Error fetching location:', error);
      });
  }
}